const bg = {
  "Home": "Начало",
  "Add": "Добави",
  "Edit": "Редакция",
  "Adding": "Добавяне на",
  "Editing": "Редактиране на",
  "Delete": "Изтрий",
  "Save": "Запази",
  "Cancel": "Отказ",
  "Close": "Затвори",
  "Open": "Отвори",
  "Users": "Потребители",
  "Are you sure you want to logout": "Сигурни ли сте, че искате да излезете?",
  "Name": "Име",
  "Password": "Парола",
  "Email": "Електронна поща",
  "Active": "Активен",
  "UserIsActive": "Потребителят е активен",
  "Filter": "Филтрирай",
  "Clear": "Изчисти",
  "Code": " Код",
  "Actions": "Действия",
  "Confirm Dialog": "Диалог за потвърждение",
  "User": "Потребител",
  "Are you sure that you want to delete": "Сигурни ли сте, че искате да изтриете",
  "Role": "Роля",
  "Region": "Регион",
  "Administrator": "Администратор",
  "ProductManager": "Мениджър на продукти",
  "RegionalManager": "Регионален мениджър",
  "Trader": "Търговец",
  "Yes": "Да",
  "No": "Не",
  "Login": "Вход",
  "Please enter email": "Моля въведете електронна поща.",
  "Please enter Password": "Моля въведете парола.",
  "Invalid E-mail or Password.": "Невалиден имейл адрес или парола.",
  "Invalid E-mail.": "Невалиден имейл адрес.",
  "Not found E-mail.": "Невалиден имейл адрес или парола.",
  "Logout": "Изход",
  "Mobile": "Мобилно",
  "You are not authorized to access this application.": "Не сте упълномощени да имате достъп до това приложение.",
  "Profile": "Профил",
  "CurrentPassword": "Текуща парола",
  "NewPassword": "Нова парола",
  "Change": "Промени",
  "FillCurrentPassword": "Моля въведете текуща парола",
  "FillNewPassword": "Моля въведете нова парола",
  "Password successfully changed": "Паролата беше променена успешно.",
  "Change password": "Промени парола",
  "Please repeat password": "Моля повторете въведената парола.",
  "Passwords dont match": "Въведените пароли не съвпадат.",
  "RepeatPassword": "Повторете паролата",
  "Data synchronization": "Синхронизация на данни ...",
  "Please wait": "Моля, изчакайте.",
  "Creating": "Създаване",
  "Opening": "Отваряне",
  "Creating a new offer": "Създаване на нова оферта",
  "Opening an existing offer": "Отваряне на съществуваща оферта",
  "new offer": "нова оферта",
  "existing offer": "на оферта",
  "Offers": "Оферти",
  "Phone": "Телефон",
  "Edit user data": "Редакция на потребителски данни",
  "Profile data succesfully saved": "Потребителските данни бяха записани успешно.",
  "1008": "Текущата парола е грешна",
  "Previous": "Предишна",
  "Next": "Следваща",
  "ClientData": "Данни за офертата",
  "TwoDPlan": "Двуизмерен план",
  "GasInstallation": "Газова инсталация",
  "HeatingInstallation": "Отоплителна инсталация",
  "Gas and heating installations": "Газова и отоплителна инсталации",
  "InstallationServices": "Монтажни услуги и материали ",
  "ConstructionWork": "Строително-монтажни работи ",
  "QuantitativeAccount": "Количествена сметка",
  "GenerateOffer": "Генериране на оферта",
  "Disctrict": "Област",
  "Municipality": "Община",
  "Town": "Град",
  "Address": "Адрес",
  "Finish": "Завърши",
  "WorkAndMaterials": "Офертата е с труд и материали",
  "BuildingType": "Тип на сградата",
  "Brick": 'Тухлена',
  "Panel": "Панелна",
  "EPK": "ЕПК",
  "IsolationType": "Вид изолация",
  "RoomHeight": "Височина на стая (cm)",
  "Position": "Изложение",
  "Client": "Клиент",
  "New": "Нов",
  "PipeInstall": "Инсталиране на тръби",
  "Floor": "Подово",
  "Ceiling": "Таванно",
  "WorkAndMaterialsAndSMR": "Допълнителни монтажни дейности и СМР",
  "Manager": "Мениджър",
  "Number": "Номер",
  "Date": "Дата",
  "Are you sure that you want to delete selected offer with ": "Сигурни ли сте, че искате да изтриете избраната оферта с ",
  "None": "Няма",
  "Inside": "Вътрешна",
  "Outside": "Външна",
  "InsideAndOutside": "Вътрешна и външна",
  "Cannot get clients from local db": "Възникна проблем с извличането на данни за клиенти от локалната база.",
  "Cannot get locations from local db": "Възникна проблем с извличането на данни за локации от локалната база",
  "Article": "Артикул",
  "Product is already added": "Избраният артикул вече е добавен!",
  "Synchronization": "Синхронизация",
  "local data with database": "на данните с базата",
  "Problem saving offer in local db.": "Възникна проблем със запазването на офертата в локалната база данни. Моля, опитайте отново.",
  "Cannot get offer from local db": "Възникна проблем със зареждането на оферта от локалните данни. Моля, опитайте отново.",
  "Cannot get offers from local db": "Възникна проблем със зареждането на оферти от локалните данни. Моля, опитайте отново.",
  "Cannot edit offer in local db": "Възникна проблем със запапазването на промяната на оферта. Моля, опитайте отново.",
  "Offer edited successfully": "Промените в офертата бяха записани успешно.",
  "GasInstallScheme": "Схема на газова инсталация",
  "HeathInstallScheme": "Схема на отоплителна инсталация",
  "Cannot get products from local db": "Възникна проблем със зареждането на артикули от локалните данни. Моля, опитайте отново.",
  "Problem deleting offer": "Възникна проблем с изтриването на офертата от локалните данни. Моля, опитайте отново.",
  "Cannot delete offer, offer is already sent": "Офертата не може да бъде изтрита, тъй като е изпратена към администрацията.",
  "Offer deleted successfully": "Офертата беше изтрита успешно.",
  "Creating new offer": "Създаване на нова оферта",
  "Editing an offer": "Редакция на оферта",
  "InCreate": "Създава се",
  "NewOffer": "Нова",
  "ContractAgreed": "Сключен договор",
  "InProcess": "Изпълнява се",
  "ContractCompleted": "Приключен договор",
  "Status": "Статус",
  "Price": "Цена",
  "BGN": "лв.",
  "EUR": "EUR",
  "Search by article number, name, brand, power, supplier...": "Търсене по артикул, номер, марка, мощност, доставчик...",
  "AxonometricScheme": "Аксонометрична схема",
  "Disclaimer": "Забележки",
  "Qty": "к-во",
  "UnitShort": "м. ед.",
  "Services": "Услуги",
  "UnitNumber": "брой",
  "UnitLinearMeter": "л.м.",
  'total records.': 'резултат(а) общо.',
  "NoGasInstallSchema": "Няма схема на газова инсталация",
  "NoHeathInstallSchema": "Няма схема на отоплителна инсталация",
  "Save & Close": "Запази и затвори",
  "Month": "Месец",
  "Quarter": "Тримесечие",
  "Year": "Година",
  "Period": "Период",
  "From": "От",
  "To": "До",
  'DateFormatUS': 'dd.MM.yyyy г.',
  "From date": "Начална дата",
  "To date": "Крайна дата",
  "Offer": "Оферта",
  "of": "от",
  "Rows per page": "Редове на страница",
  "Filters": "Филтри",
  "View all": "Виж всички",
  "No records found": "Няма намерени записи.",
  'Data Saved Successfully': "Данните бяха записани успешно",
  "Please enter cleint name.": "Моля, въведете име на клиента.",
  "Please enter cleint address.": "Моля, въведете адрес на клиента.",
  "GRT": "ГРТ",
  "Gas Board": "Газово разпределително табло",
  "GIT": 'ГИТ',
  "Gas Measuring Board": "Газово измервателно табло",
  "Windows": "Прозорци",
  "Doors": "Врати",
  "Annotations": "Анотации",
  "Stairs": "Стълби",
  "Circular stairs": "Вити стълби",
  "Round column": "Кръгла колона",
  "Square column": "Квадратна колона",
  "U Shape": "U форма",
  "T Shape": "T форма",
  "Square Shape": "Квадратна форма",
  "L Shape": "L форма",
  "Shape": "Правоъгълна форма",
  "Wall": "Стена",
  "Window": "Прозорец",
  "Sash Window": "Прозорец на две части",
  "Venetian Blind Window": "Венециански прозорец",
  "Curtain Window": "Прозорец с щори",
  "Door": "Врата",
  "Double Door": "Двойна врата",
  "Gate": "Отвор",
  "Panic Door": "Паник врата",
  "Double Panic Door": "Двойна паник врата",
  "Sliding Door": "Плъзгаща врата",
  "Text": "Текст",
  "Label": "Етикет",
  "North Sign": "Знак север",
  "Elevation Sign": "Кота",
  "Circle Pointer": "Етикет с кръг",
  "Chimney Sign": "Комин",
  "Pipe": "Тръба",
  "Client information": "Информация за клиента",
  "Total": "Общо",
  "Price without VAT": "Цена без ДДС",
  "Total without VAT": "Общо без ДДС",
  "Void": "Кухина",
  "Void Circle": "Кръгла кухина",
  "Client name": "Име на клиент",
  "Choose client": "Избери клиент",
  "Client search": "Търсене на клиент",
  "Choose": "Избери",
  "Search": "Търси",
  "Search by name, phone, email": "Търсене по име, телефон, email ...",
  "Cannot get result from client search": "Възникна проблем при търсене на клиенти. Моля, опитайте отново.",
  "New client": "Нов клиент",
  "Edit client": "Реадакция на клиент",
  "Edit address": "Редакция на адрес",
  "Total after discount": "Обща сума след отстъпка без ДДС",
  "VAT": "ДДС",
  "Signature": "Подпис",
  "Sales Representative": "Търговски представител",
  "Phone for contact": "Телефон за контакти",
  "Accept the offer": "Приемам предложението",
  "Discount": "Отстъпка (%)",
  "Installation": "Инсталация",
  "Total with VAT": "Общо с ДДС",
  "Validity of the proposal": "Валидност на предложението",
  "to": "до",
  'Copy': 'Копирай',
  'Paste': 'Постави',
  'NoTwoDimPlan': 'Избраната оферта няма двуизмерен план',
  "Send": "Изпрати",
  "Report offer no network connection": "Няма връзка със сървъра. Офертата не може да бъде изпратена към администрацията.",
  "Synchronization please wait": "Синхронизация на данни ... Моля, изчакайте.",
  "You have not synchronized offers that may be lost. Do you want to logout?": "Имате неизпратени оферти, които могат да бъдат изгубени. Сигурни ли сте, че искате да излезете?",
  "Fittings": "Фитинги",
  "Transitional Holender": "Преходен холендер",
  "Magnet Ventil": "Магнет Вентил",
  "Coupling": "Муфа",
  "Nipel": "Нипел",
  "Triple": "Тройник",
  "Ventil": "Вентил",
  "Gas Pipe": "Газова тръба",
  "Water Pipe": "Водно-отоплителна тръба",
  "GasInstallPrice": "Газова инсталация (общо без ДДС)",
  "HeathInstallPrice": "Отоплителна инсталация (общо без ДДС)",
  "Services and materials": "Монтажни услуги и материали",
  "Cannot get offers for synchronization from local db": "Възникна проблем при зареждането на оферти за синхронизация от локалната база.",
  "5001": "Възникна проблем с обработката на оферти на сървъра. 5001",
  "Cannot set offers as reported": "Възникна проблем при отбелязване на офертите като изпратени в локалната база",
  "Cannot set remote ids to newly created offers": "Възникна проблем при обновяване на идентификаторите на синхронизираните оферти в локалната база.",
  "Error clearing local database": "Възникна проблем с изчистването на данни от локалната база.",
  "5000": "Възникна проблем с получаването на данни от сървъра. 5000",
  "Error inserting synchronization data from server": "Възникна проблем със запазването на данните в локалната база.",
  "Try again": "Опитай пак",
  "Elbow": "Коляно",
  "Installation services": "Монтажни услуги",
  "Equipment and materials": "Окомплектовка и материали",
  "Lyre": "Лира",
  "Bill of quantities": "Кол. сметка уреди и материали",
  "Bill of quantities labor": "Кол. сметка труд",
  "2DScheme": "2D схема",
  "Generate": "Генерирай",
  "vertical pipe": "Вертикална тръба",
  "vertical gas pipe": 'Газова вертикална тръба',
  "vertical water pipe": "Водно-отоплителна вертикална тръба",
  "CalculatePipes": "Изчисляване на газова инсталация",
  "ProductsPower": "Обща консумация:",
  "PipeSumLength": "Дължина на тръбите",
  "PipesDiameter": "Диаметър на тръбите:",
  "Offer recalculation succesfull": "Офертата беше преизчислена успешно.",
  "Problem recalculating offer": "Възникна проблем при преизчисляване на офертата.",
  "Cannot update offer in local db": "Възникна грешка при обновяване на офертата в локалната база.",
  "AxonometricSchemeG": "Аксонометрична схема на ГИ",
  "AxonometricSchemeH": "Аксонометрична схема на ВОИ",
  "GasInstallAxonometry": "Аксонометрична схема на газова инсталация",
  "HeathInstallAxonometry": "Аксонометрична схема на отоплителна инсталация",
  "Recalculate Offer": "Преизчисли оферта",
  "without vat": "без ДДС",
  "Please add at least one item to 2D schema.": "Моля добавете елементи на 2D схемата.",
  "Please add at least one item to Gas installation schema.": "Моля добавете елементи на Газовата схема.",
  "Please add at least one item to Heat installation schema.": "Моля добавете елементи на Отоплителната схема.",
  "Index": "Позиция",
  "AddFittings": "Добави фитинги",
  "NoGasPipesFound": "Няма отркити газови тръби",
  "NoFittingsFound": "Няма отркити фитинги",
  "AllFittings": "Всички фитинги",
  "Elbows": "Колена",
  "Triples": "Тройници",
  "Installation articles": "Артикули от инсталацията",
  "No articles added to installation": "Няма добавени артикули към инсталацията.",
  "Nipels": "Нипели",
  "Article number": "Артикулен номер",
  "Cannot get max diamater from pipes": "Не може да бъде извлечен най-големия диаметър от тръбите.",
  "Please add products with power": "Моля добавете уред(и) със зададена мощност!",
  "You have pipes without diameter": "Имате тръби, които нямат диаметър!",
  "Installation is not designed properly": "Инсталацията не е проектирана правилно.",
  "Please add stabilizer or increase pipes diameter": "Моля, добавете стабилизитор или увеличете диаметъра на тръбите.",
  "Installation is designed properly": "Инсталацията е правилно проектирана",
  "Discount amount without VAT": "Сума на отстъпка без ДДС",
  "Status changes": "История на статусите",
  "Settings": "Настройки",
  "Bulgarian": "Български",
  "English": "Английски",
  "Language": "Език",
  "Local data": "Локални данни",
  "Clear local data": "Изчистване на локални данни",
  "Are you sure you want to clear local data": "Сигурни ли сте, че искате да изчистите локалните данни?",
  "Get location": "Вземи локация",
  "Get location problem occur": "Възникна проблем при получаването на данни за текущата локация. Моля, опитайте отново.",
  "Problem getting data from server. You see only local offers. ": "Възникна проблем с получаването на данни от сървъра. Виждате само локално заредените оферти.",
  "No connection with server. You see only local offers": "Няма връзка със сървъра. Виждате само локално заредените оферти.",
  "Problem deleting offer on server": "Възникна проблем с изтриването на офертата на сървъра.",
  "Offer send successfully": "Офертата беше изпратена успешно.",
  "Problem with offer pdf file": "Възникна проблем с PDF файла на офертата",
  "AddedFittings": "Добавени фитинги",
  "Expired": "Изтекла",
  "Accepted": "Приета",
  "InExecution": "В изпълнение",
  "Finished": "Приключена",
  "Email sending failed": "Грешка при изпращането на електронна поща",
  "SendEmail": "Изпрати на клиента",
  "Data Saved Successfully Local": "Данните бяха записани успешно в устройството",
  "Data Saved Successfully Server": "Данните бяха записани успешно в базата",
  "Notes": "Бележки",
  "AdminNote": "Сумата по това Ценово предложение, не е окончателна и може да търпи промяна. В случай, че са извършени допълнителни услуги и са вложени допълнително материали, които не са включени в изброените се изравняват с окончателен протокол и фактура.",
  "Please add email to client data.": "Моля, въведете електронна поща в данните на клиент!",
  "Do you confirm sending": "Потвърждавате ли изпращането на",
  "to client": "към клиент",
  "with email": "с електронна поща",
  '6000': 'Имейл сървъра е празен',
  '6001': 'Имейл порта е празен',
  '6002': 'Имейл потребителя е празен',
  '6003': 'Имейл паролата на потребителя е празна',
  '6004': 'Имейл сокета е празен',
  '6005': 'Имейл получателя е празен',
  '6006': 'Имейл изпращача е празен',
  '6007': 'Имейл темата е празна',
  '6008': 'Имейл съдържанието е празно',
  "Equipment only": "Само доставка и монтаж на оборудване",
  "Article No": "Артикулен №",
  "Naming": "Наименование",
  "Measure": "Мярка",
  "Quantity Short": "Кол.",
  "Supplier": "Доставчик",
  "Note": "Забележка",
  "Request for materials": "ЗАЯВКА за материали",
  "Request for installation services": "ЗАЯВКА за монтажни услуги",
  "Request Num": "Заявка №",
  "Contract Num": "Договор №",
  "Request date": "Дата на заявката",
  "Montage address": "Адрес за монтаж",
  "Montage term": "Срок за монтаж",
  "Receiver name": "Име на получател",
  "Contact phone": "Телефон за контакт",
  "Special client requirements": "Специални изисквания на клиента",
  "Offer status": "Статус на офертата",
  "Profile offline warning msg": "В момента сте в оффлайн режим. За да редактирате профила си, уверете се, че имате връзка с интернет и опитайте отново.",
  "Changed by system": "Системна промяна",
  "Article number or name": "Артикулен номер или име",
  "Showing from": "Показани от",
  "from": "от",
  "copper pipes": "Тръби медни",
  "underground pipes": "Тръби за подземен монтаж",
  "polyethylene pipes with aluminum insert": "Полиетиленови тръби с алуминиева вложка",
  "BDS": "БДС EN 1057:2006+A1:2010",
  "Tee": "Тройник",
  "Tees": "Тройници",
  "pcs": "бр.",
  "nipple": "нипел",
  "Nipple": "Нипел",
  "Nipples": "Нипели",
  "nipples": "нипели",
  "w/о VAT": "без ДДС",
  "Please enter cleint town.": "Моля, въведете град на клиента.",
  "Please enter two client names.": "Моля въведете две имена на клиента.",
  "Executed Quantity Short": "Изпълнено кол.",
  "Delivery address": "Адрес за доставка",
  "Discount (BGN)": "Отстъпка (лв.)",
}

export default bg;